import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationCityOnboardPostBody,
  IConfigurationCityOnboardResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationCityOnboardAPI = () => {
  const [newCityId, setNewCityId] = useState<string>("");
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (cityData: IConfigurationCityOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!cityData) {
          return;
        }
        await axios
          .post(`${CONFIGURATION_APIS?.CITY_ONBOARD?.baseURL}`, JSON.stringify(cityData), {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationCityOnboardResponse>) => {
            if (res.data.status === true) {
              setNewCityId(res?.data?.data?.city_id);
              toast.success(`City ${cityData?.city_name} , onboarded successfully. `);
            } else {
              // console.log("not created");
              toast.error("Cannot create city.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("City already exists");
            // toast.error("Error at server while creating city.");
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
          // if (axiosError.response?.status === 400) {
          //   toast.error(axiosError.message);
          // }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { newCityId, execute };
};
